import React from 'react';
import { motion } from 'framer-motion';
import { BanknoteIcon, ShieldCheckIcon, TrendingDownIcon, GlobeIcon } from 'lucide-react';
type Metric = {
  value: string;
  label: string;
  detail: string;
  source: string;
  Icon: typeof BanknoteIcon;
};
const METRICS: Metric[] = [{
  value: '$24B',
  label: 'Capital Unlocked',
  detail: 'Directed Treasury & Regulatory alignment at JPMorgan Chase to optimize capital adequacy.',
  source: 'JPMorgan Chase',
  Icon: BanknoteIcon
}, {
  value: '88',
  label: 'MRAs Remediated',
  detail: 'Zero-failure strategist in high-stakes Federal Reserve and OCC regulatory remediation.',
  source: 'Deutsche Bank',
  Icon: ShieldCheckIcon
}, {
  value: '$4.3M',
  label: 'Annual Savings',
  detail: 'Operational cost rationalization and efficiency program execution at Bank of Ireland.',
  source: 'Bank of Ireland',
  Icon: TrendingDownIcon
}, {
  value: '20+',
  label: 'Years Leadership',
  detail: 'Executive scale managing global finance operations across NY, London, Tokyo, Hong Kong, and Sydney.',
  source: 'Career to date',
  Icon: GlobeIcon
}];
const SUPPORTING = [{
  value: '570',
  label: 'FTE hours automated out of regulatory reporting annually'
}, {
  value: '3',
  label: 'Enterprise finance platform implementations led end to end'
}, {
  value: '100%',
  label: 'Supervisory findings closed without repeat issuance'
}];
export function MetricsBanner() {
  return <>
      <section aria-labelledby="impact-heading" className="w-full bg-white" data-id="element-222" data-mp="2c9cdveozj1az">
        <div className="mx-auto max-w-content px-6 py-20 sm:py-24 lg:px-8" data-id="element-223" data-mp="2r6369408rcr3">
          <h2 id="impact-heading" className="text-[11px] font-semibold uppercase tracking-widest text-navy-700" data-id="element-224" data-mp="2m6gqonwxxkf4">
            The Four Defining Metrics
          </h2>

          <div className="mt-10 grid grid-cols-1 gap-px border border-slateink-300/70 bg-slateink-300/70 sm:grid-cols-2 lg:grid-cols-4" data-id="element-225" data-mp="1g85zsjv30or">
            {METRICS.map((metric, i) => <motion.article key={metric.label} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.08,
            ease: [0.22, 1, 0.36, 1]
          }} className="group relative flex flex-col bg-white p-8 transition-colors duration-300 hover:bg-slateink-100" data-id="element-226" data-mp="8liun5we6s0k" data-mpi={i}>
                <span className="absolute inset-x-0 top-0 h-px bg-gold-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100" aria-hidden="true" data-id="element-227" data-mp="3qygy3mse82zh" />
                <metric.Icon className="h-5 w-5 text-gold-600" aria-hidden="true" strokeWidth={1.5} data-id="element-228" data-mp="4imctheoezxo" />
                <p className="mt-6 font-serif text-4xl text-navy-900 sm:text-[42px]" data-id="element-229" data-mp="3864l86445jb3">
                  {metric.value}
                </p>
                <p className="mt-2 text-[12px] font-semibold uppercase tracking-wider text-navy-700" data-id="element-230" data-mp="1pb0f79ipt9z1">
                  {metric.label}
                </p>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-slateink-600" data-id="element-231" data-mp="1galotvqw94oo">
                  {metric.detail}
                </p>
                <p className="mt-6 border-t border-slateink-300/70 pt-4 text-[10px] uppercase tracking-widest text-slateink-500" data-id="element-232" data-mp="1bbio2nhy5kmi">
                  {metric.source}
                </p>
              </motion.article>)}
          </div>
        </div>
      </section>

      <section aria-labelledby="supporting-metrics" className="w-full bg-navy-950" data-id="element-233" data-mp="xlow3wb5ak8k">
        <div className="mx-auto max-w-content px-6 py-16 sm:py-20 lg:px-8" data-id="element-234" data-mp="sm2hbifo4vxn">
          <h2 id="supporting-metrics" className="text-[11px] font-semibold uppercase tracking-widest text-gold-400" data-id="element-235" data-mp="nmg438zubfou">
            Supporting Quantified Outcomes
          </h2>
          <dl className="mt-10 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-3" data-id="element-236" data-mp="2ipw43e6p69cd">
            {SUPPORTING.map(item => <div key={item.value} className="bg-navy-950 p-8" data-id="element-237" data-mp="2nnnu22ns7ldx">
                <dt className="font-serif text-3xl text-white" data-id="element-238" data-mp="2902q66j31i4y">{item.value}</dt>
                <dd className="mt-3 text-sm leading-relaxed text-slateink-300" data-id="element-239" data-mp="28xyo7u4qut7b">
                  {item.label}
                </dd>
              </div>)}
          </dl>
        </div>
      </section>
    </>;
}